<template>
  <div>
    <input ref="proof" class="file-proxy" type="file" accept="image/jpeg,image/png,application/pdf,.jpg,.jpeg,.png,.pdf" @change="onProof" />
    <div class="ch-head">
      <div>
        <h1>代金券获取</h1>
        <p>代金券购买（仅线下对公转账） · 代金券申请与总平台审批 · 获取记录</p>
      </div>
      <div class="ch-actions head-side">
        <div class="used">已使用积分：<b>{{ usedPoints.toLocaleString() }}</b> 分</div>
      </div>
    </div>
    <div class="ch-tabs">
      <button type="button" :class="{ on: tab === 'buy' }" @click="tab = 'buy'">购买代金券</button>
      <button type="button" :class="{ on: tab === 'apply' }" @click="tab = 'apply'">申请代金券</button>
      <button type="button" :class="{ on: tab === 'log' }" @click="tab = 'log'">购买与申请记录</button>
    </div>
    <div v-if="tab !== 'log'" class="ch-faces">
      <button v-for="item in faces" :key="item" type="button" class="ch-face" :class="{ on: !custom && Number(form.faceValue) === item }" @click="pick(item)">
        <em v-if="item === 50000" class="rec">推荐</em>
        <div class="k">代金券面值</div>
        <div class="v">¥ {{ item.toLocaleString() }}</div>
        <div class="s">{{ facePay(item) }}</div>
      </button>
      <button type="button" class="ch-face" :class="{ on: custom }" @click="custom = true">
        <div class="k">自定义面值</div>
        <div class="v">—</div>
        <div class="s">最低 ¥ 1,000 起</div>
      </button>
    </div>
    <div v-if="tab === 'buy'" class="ch-grid2">
      <div class="ch-panel">
        <div class="form-grid">
          <label>购买面值（元） *
            <input v-model="form.faceValue" @input="onFace" />
          </label>
          <label>到账代金券面值
            <input :value="faceText + ' 元'" readonly />
          </label>
          <label>支付方式 *
            <select v-model="payWay">
              <option value="bank">对公转账（仅支持线下对公转账）</option>
            </select>
          </label>
          <label>发票需求
            <select v-model="form.invoiceNeed">
              <option value="需要增值税专用发票">需要增值税专用发票</option>
              <option value="需要增值税普通发票">需要增值税普通发票</option>
              <option value="不需要发票">不需要发票</option>
            </select>
          </label>
        </div>
        <div class="drop" @click="pickProof" @dragover.prevent @drop.prevent="onDrop">
          <i class="el-icon-upload" />
          <p>点击上传转账凭证，或将文件拖拽到此处（可不上传）</p>
          <small>上传后由总部财务核对到账。未上传单据时由总部电话等方式确认到账</small>
          <b v-if="proofName">{{ proofName }}</b>
        </div>
      </div>
      <div class="ch-panel quote">
        <h2>费用试算</h2>
        <div class="quote-row"><span>代金券面值</span><b>{{ faceText }}</b></div>
        <div class="quote-row"><span>折扣（{{ levelLabel }}）</span><b>{{ discountText(discount) }}</b></div>
        <div class="quote-row muted"><span>购买价格</span><span>{{ priceHint }}</span></div>
        <div class="quote-total"><span>应付总额</span><b>{{ payLine }}</b></div>
        <button class="ch-btn gold block" type="button" :disabled="submitting || faceNumber < 1000" @click="submit('PURCHASE')">提交申请</button>
        <p class="hint">提交后可在「购买与申请记录」中查看进度。未上传单据时总部电话等方式确认到账后点击确认到账。</p>
        <p class="hint">购买申请不设超时自动关闭，可随时补充上传转账单据。</p>
      </div>
    </div>
    <div v-else-if="tab === 'apply'" class="ch-panel">
      <h2>申请代金券</h2>
      <div class="ch-filters">
        <label>申请面值（元）<input v-model="form.faceValue" @input="onFace" /></label>
      </div>
      <p class="ch-note">所有渠道商的申请都交给总平台审批。通过后由总部划拨到「我的卡券」。申请入口长期保留。</p>
      <label class="reason">申请理由
        <textarea v-model="form.applyReason" maxlength="500" rows="3" placeholder="请说明申请原因"></textarea>
      </label>
      <div style="margin-top:12px"><button class="ch-btn gold" type="button" :disabled="submitting" @click="submit('APPLY')">提交申请</button></div>
    </div>
    <div v-else class="ch-panel">
      <h2>购买与申请记录</h2>
      <table class="ch-table">
        <thead><tr><th>时间</th><th>类型</th><th>面值</th><th>实付</th><th>申请理由</th><th>状态</th><th>单据</th></tr></thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td>{{ timeText(row.createdAt) }}</td>
            <td>{{ statusName(row.source) }}</td>
            <td>¥ {{ yuan(row.faceValue) }}</td>
            <td>{{ row.payAmount != null ? '¥ ' + yuan(row.payAmount) : '—' }}</td>
            <td>{{ row.applyReason || '—' }}</td>
            <td><span class="ch-tag" :class="tagOf(row.status)">{{ statusName(row.status) }}</span></td>
            <td>
              <button v-if="row.proofUrl" class="ch-link" type="button" @click="viewProof(row)">查看凭证</button>
              <button v-if="row.status === 'PENDING_PAY'" class="ch-link" type="button" @click="supplement(row)">补充凭证</button>
              <span v-if="!row.proofUrl && row.status !== 'PENDING_PAY'">—</span>
            </td>
          </tr>
          <tr v-if="!records.length"><td colspan="7" class="ch-empty">还没有购买或申请记录</td></tr>
        </tbody>
      </table>
    </div>
    <div v-if="tab === 'buy'" class="bank">
      <i class="el-icon-office-building" />
      <div>
        <b>收款账户</b>
        <p>{{ bank.companyName }}（{{ bank.bankName }} {{ bank.accountNo }}）</p>
        <p>转账备注请填写渠道名称「{{ partnerName || '本渠道' }}」{{ inviteCode ? '或邀请码 ' + inviteCode : '' }}，便于核对到账。</p>
      </div>
      <button class="ch-btn" type="button" @click="copyBank">复制账户</button>
    </div>
    <div v-if="tab === 'buy'" class="flow">
      <span>购买流程</span>
      <i>提交申请</i><em>→</em>
      <i>线下转账</i><em>→</em>
      <i class="opt">提交转账单据（可选）</i><em>→</em>
      <i>总部确认</i><em>→</em>
      <i>划拨发放</i>
    </div>
    <el-dialog title="转账凭证" :visible.sync="proofView.open" width="720px" append-to-body>
      <div class="proof-view">
        <img v-if="proofView.image" :src="proofView.url" alt="凭证" />
        <p v-else class="ch-empty">当前凭证不是图片，请下载后查看</p>
        <button class="ch-btn" type="button" :disabled="proofView.saving" @click="downloadProof">下载凭证</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelOverview, getChannelVouchers, createChannelVoucher, updateChannelVoucherProof } from '@/api/admin'
import { uploadFile } from '@/api/upload'
import { normalizeFileUrl, resolveFileUrl } from '@/utils/fileUrl'
import { discountText, levelName, statusName, yuan } from './labels'

const BANK = {
  companyName: '星河逐梦（福建）科技有限公司',
  creditCode: '91350104MAKHQW4K74',
  bankName: '招商银行鼓楼支行',
  accountNo: '591911717810001'
}

export default {
  name: 'PartnerRecharge',
  data() {
    return {
      discount: null,
      levelCode: '',
      partnerName: '',
      inviteCode: '',
      list: [],
      custom: false,
      tab: 'buy',
      payWay: 'bank',
      faces: [1000, 5000, 10000, 50000],
      form: { faceValue: 50000, proofUrl: '', invoiceNeed: '需要增值税专用发票', applyReason: '' },
      proofName: '',
      submitting: false,
      picking: false,
      proofMode: 'buy',
      laterId: null,
      bank: BANK,
      proofView: { open: false, url: '', image: false, saving: false, source: '' }
    }
  },
  computed: {
    records() {
      return this.list.filter(item => item.source === 'PURCHASE' || item.source === 'APPLY')
    },
    usedPoints() {
      return this.list.filter(item => item.status === 'USED')
        .reduce((sum, item) => sum + Math.round(Number(item.faceValue || 0) * 10), 0)
    },
    faceNumber() {
      const n = Number(this.form.faceValue)
      return Number.isFinite(n) ? n : 0
    },
    faceText() {
      return this.faceNumber ? this.faceNumber.toLocaleString('zh-CN') : '0'
    },
    levelLabel() {
      return levelName(this.levelCode)
    },
    hasDiscount() {
      return this.discount != null && this.discount !== ''
    },
    payLine() {
      if (this.faceNumber < 1000) return '面值最低 1,000 元'
      return '¥ ' + yuan(this.payable(this.faceNumber))
    },
    priceHint() {
      return this.hasDiscount ? '面值 × 对应级别折扣' : '无进货折扣，按面值原价'
    }
  },
  created() {
    if (this.$route.query.tab === 'apply' || this.$route.query.tab === 'log') this.tab = this.$route.query.tab
    this.load()
  },
  methods: {
    discountText, statusName, yuan, levelName,
    pick(item) {
      this.custom = false
      this.form.faceValue = item
    },
    onFace() {
      this.custom = this.faces.indexOf(Number(this.form.faceValue)) < 0
    },
    payable(face) {
      const amount = Number(face)
      if (!this.hasDiscount) return amount
      return amount * Number(this.discount)
    },
    facePay(face) {
      const pay = this.payable(face)
      const text = Number.isInteger(pay) ? pay.toLocaleString('zh-CN') : yuan(pay)
      if (!this.hasDiscount) return '无进货折扣 · 实付 ' + text
      return discountText(this.discount) + ' · 实付 ' + text
    },
    tagOf(status) {
      if (status === 'UNUSED' || status === 'USED') return 'ok'
      if (status === 'REJECTED' || status === 'EXPIRED') return 'bad'
      return 'warn'
    },
    timeText(value) {
      if (!value) return '—'
      return String(value).replace('T', ' ').slice(0, 19)
    },
    viewProof(row) {
      const url = resolveFileUrl(row && row.proofUrl)
      if (!url) return
      const image = /\.(png|jpe?g|gif|webp|bmp)(\?|$)/i.test(String(row.proofUrl || ''))
      this.proofView = { open: true, url, image, saving: false, source: row.proofUrl || url }
    },
    proofFileName(url) {
      const path = String(url || '').split('?')[0]
      const name = path.split('/').pop() || 'voucher-proof'
      if (/\.[a-z0-9]+$/i.test(name)) return name
      return name + '.jpg'
    },
    async downloadProof() {
      const url = this.proofView.url
      if (!url || this.proofView.saving) return
      this.proofView.saving = true
      const name = this.proofFileName(this.proofView.source || url)
      try {
        const response = await fetch(url, { mode: 'cors' })
        if (!response.ok) throw new Error('download failed')
        const blob = await response.blob()
        const objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(objectUrl)
      } catch (e) {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.rel = 'noopener'
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } finally {
        this.proofView.saving = false
      }
    },
    pickProof() {
      this.openProof('buy')
    },
    openProof(mode) {
      if (this.picking) return
      this.picking = true
      this.proofMode = mode
      const open = () => {
        const input = this.$refs.proof
        if (input) input.click()
        window.setTimeout(() => { this.picking = false }, 800)
      }
      if (mode === 'buy' && this.tab !== 'buy') {
        this.tab = 'buy'
        this.$nextTick(open)
        return
      }
      open()
    },
    onDrop(event) {
      const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]
      this.proofMode = 'buy'
      this.storeProof(file)
    },
    onProof(event) {
      const file = event.target.files && event.target.files[0]
      event.target.value = ''
      if (this.proofMode === 'later') {
        this.onLaterFile(file)
        return
      }
      this.storeProof(file)
    },
    async storeProof(file) {
      if (!file) return
      const name = String(file.name || '').toLowerCase()
      if (!/\.(jpg|jpeg|png|pdf)$/.test(name)) {
        this.$message.warning('只支持 JPG、PNG、PDF')
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning('单个文件不能超过 5MB')
        return
      }
      const result = await uploadFile(file, 'voucher-proof', { useAdmin: true })
      this.form.proofUrl = normalizeFileUrl(result.url)
      this.proofName = file.name
    },
    supplement(row) {
      this.laterId = row.id
      this.openProof('later')
    },
    async onLaterFile(file) {
      const id = this.laterId
      this.laterId = null
      if (!file || !id) return
      await this.storeProof(file)
      if (!this.form.proofUrl) return
      await updateChannelVoucherProof(id, { proofUrl: this.form.proofUrl })
      this.$message.success('凭证已补充')
      this.form.proofUrl = ''
      this.proofName = ''
      this.load()
    },
    copyBank() {
      const text = [
        '公司名称：' + this.bank.companyName,
        '统一信用代码：' + this.bank.creditCode,
        '开户行：' + this.bank.bankName,
        '银行账号：' + this.bank.accountNo
      ].join('\n')
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(input)
      if (ok) this.$message.success('账户信息已复制')
      else this.$message.warning('复制失败，请手动选择文字')
    },
    async load() {
      const overview = await getChannelOverview()
      const partner = (overview && overview.partner) || {}
      this.discount = overview ? overview.discount : null
      this.levelCode = partner.levelCode || ''
      this.partnerName = partner.name || ''
      this.inviteCode = partner.inviteCode || ''
      const vouchers = await getChannelVouchers()
      this.list = (vouchers && vouchers.list) || []
    },
    async submit(source) {
      const face = this.faceNumber
      if (face < 1000) {
        this.$message.warning('面值最低 1,000 元')
        return
      }
      const applyReason = (this.form.applyReason || '').trim()
      if (source === 'APPLY' && !applyReason) {
        this.$message.warning('请填写申请理由')
        return
      }
      this.submitting = true
      try {
        await createChannelVoucher({
          faceValue: face,
          source,
          proofUrl: source === 'PURCHASE' ? this.form.proofUrl : '',
          invoiceNeed: source === 'PURCHASE' ? this.form.invoiceNeed : '',
          applyReason: source === 'APPLY' ? applyReason : ''
        })
        this.$message.success('已提交')
        this.form.proofUrl = ''
        this.form.applyReason = ''
        this.proofName = ''
        this.tab = 'log'
        this.load()
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.head-side { align-items: center; }
.used { color: #5c6780; font-size: 13px; }
.used b { color: #1a2468; font-size: 16px; }
.ch-face { position: relative; }
.rec { position: absolute; top: 10px; right: 10px; background: #eef1fb; color: #2f4dbf; border-radius: 999px; padding: 1px 8px; font-size: 12px; font-style: normal; }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px 16px; }
.form-grid label { display: flex; flex-direction: column; gap: 6px; color: #5c6780; font-size: 13px; }
.form-grid input, .form-grid select { height: 36px; border: 1px solid #d9dfec; border-radius: 8px; padding: 0 10px; color: #1f2a44; background: #fff; }
.form-grid input[readonly] { background: #f7f8fc; }
.drop { margin-top: 16px; border: 1px dashed #d5dced; border-radius: 12px; min-height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; color: #7b8499; text-align: center; cursor: pointer; padding: 16px; }
.drop i { font-size: 28px; color: #9aa6c2; }
.drop p { margin: 0; color: #24304a; }
.drop small { color: #98a0b3; }
.file-proxy { position: fixed; left: 0; top: 0; width: 1px; height: 1px; opacity: 0; overflow: hidden; pointer-events: none; }
.quote-row, .quote-total { display: flex; justify-content: space-between; gap: 12px; margin: 10px 0; font-size: 13px; color: #5c6780; }
.quote-row b, .quote-total b { color: #1a2468; }
.quote-row.muted { color: #98a0b3; }
.quote-total { margin-top: 16px; padding-top: 12px; border-top: 1px solid #eef1f6; }
.quote-total b { font-size: 20px; }
.block { width: 100%; height: 40px; }
.hint { margin: 8px 0 0; color: #98a0b3; font-size: 12px; line-height: 1.6; }
.reason { display: flex; flex-direction: column; gap: 6px; margin-top: 12px; color: #5c6780; font-size: 13px; max-width: 560px; }
.reason textarea { border: 1px solid #d9dfec; border-radius: 8px; padding: 8px 10px; color: #1f2a44; resize: vertical; font: inherit; }
.bank { display: flex; align-items: center; gap: 12px; background: #fff; border: 1px solid #e7ebf3; border-radius: 12px; padding: 14px 16px; margin-bottom: 14px; }
.bank i { color: #2f4dbf; font-size: 18px; }
.bank p { margin: 2px 0 0; color: #5c6780; font-size: 13px; }
.bank b { color: #1a2468; }
.flow { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; color: #5c6780; font-size: 13px; }
.flow i { font-style: normal; background: #fff; border: 1px solid #e7ebf3; border-radius: 999px; padding: 4px 10px; color: #1a2468; }
.flow i.opt { background: #fff8eb; border-color: #f3dfb0; }
.flow em { color: #c5cbe0; font-style: normal; }
.proof-view { text-align: center; }
.proof-view img { max-width: 100%; max-height: 70vh; border-radius: 8px; display: block; margin: 0 auto 12px; }
.proof-view .ch-btn { display: inline-block; line-height: 34px; border: 0; cursor: pointer; }
.proof-view .ch-btn:disabled { opacity: .6; cursor: wait; }
@media (max-width: 1100px) {
  .form-grid { grid-template-columns: 1fr; }
}
</style>
